import styled from 'styled-components';
import Tooltip from '@prisjakt/ui-tooltip';

export const ClearFilterTooltip = styled(Tooltip)`
  max-width: 100px;
`;

export const ToggleColumnTooltip = styled(Tooltip)`
  max-width: 130px;
`;
